const VALIDATE_ELEMENTS = {
    form: '.js-m-form',
    fields: '.js-m-validate',
    container: '.js-field-wrap',
    errorClassName: 'is-error',
    button: '.js-submit-form',
    buttonDisabledClassName: 'disabled',
    selectItem: '.js-select-item',
    textLimit: '.js-textarea-limit',
    popupWrapper: '.m-popup-wrapper',
    popupForm: '.js-m-popup',
    popupSuccess: '.js-m-popup-success',
    popupClose: '.js-close-popup',
    popupHideClassName: 'is-hide',
    popupShowClassName: 'is-show',
    errorInputWrap: '.js-error-wrap'
};

const STATE = {
    disableScroll: 'is-disabled-scroll'
};

/**
 * проверка формы на ошибки и выставления класса кнопки отправки
 * @param submitButton {HTMLElement} - кнопка отправки формы
 */
function checkForm(submitButton) {
    const inputWrapper = document.querySelectorAll(VALIDATE_ELEMENTS.container);
    for (let i = 0; i < inputWrapper.length; i++) {
        if (inputWrapper[i].classList.contains(VALIDATE_ELEMENTS.errorClassName)) {
            submitButton.classList.add(VALIDATE_ELEMENTS.buttonDisabledClassName);
            return false;
        }
    }
    submitButton.classList.remove(VALIDATE_ELEMENTS.buttonDisabledClassName);
    return true;
}

/**
 * проверка email через регулярное выражение
 * @param email {String}
 * @returns {boolean}
 */
function validateEmail(email) {
    const regexEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return !!email.match(regexEmail);
}
/**
 * проверка полей
 * @param field {HTMLElement} - input
 * @param field.value {String} - значение input
 * @param submitButton {HTMLElement}  - кнопка отправки формы
 */
function inputValidate(field, submitButton) {
    const wrapper = field.closest(VALIDATE_ELEMENTS.container);
    if (field.dataset.validate === 'message') {
        const limit = 300;
        const errorBlock = wrapper.querySelector(VALIDATE_ELEMENTS.errorInputWrap);
        const limitText = wrapper.querySelector(VALIDATE_ELEMENTS.textLimit);

        if (field.value?.length === 0 && field.dataset.svalidate === 'notEmpty') {
            wrapper.classList.add(VALIDATE_ELEMENTS.errorClassName);
            errorBlock.textContent = 'Поле обязательно для заполнения';
        } else if (field.value?.length > limit) {
            wrapper.classList.add(VALIDATE_ELEMENTS.errorClassName);
            limitText.textContent = `${limit - field.value.length}/${limit}`;
            errorBlock.textContent = 'Превышено допустимое количество символов';
        } else {
            wrapper.classList.remove(VALIDATE_ELEMENTS.errorClassName);
            limitText.textContent = '';
        }
    } else if (field.dataset.validate === 'email') {
        if (validateEmail(field.value)) {
            wrapper.classList.remove(VALIDATE_ELEMENTS.errorClassName);
        } else {
            wrapper.classList.add(VALIDATE_ELEMENTS.errorClassName);
        }
    } else {
        let lengthNumber = 2;
        if (field.dataset.validate === 'phone') {
            lengthNumber = 18; // вместе с маской получается 18
        }
        if (field.value?.length < lengthNumber) {
            wrapper.classList.add(VALIDATE_ELEMENTS.errorClassName);
        } else {
            wrapper.classList.remove(VALIDATE_ELEMENTS.errorClassName);
        }
    }
    checkForm(submitButton);
}

export default function formsValidate() {
    const forms = document.querySelectorAll(VALIDATE_ELEMENTS.form);

    if (!forms.length) { return false; }

    forms.forEach((form) => {
        const validateFields = form.querySelectorAll(VALIDATE_ELEMENTS.fields);
        const submitButton = form.querySelector(VALIDATE_ELEMENTS.button);
        const popup = form.parentElement.querySelector(VALIDATE_ELEMENTS.popupForm);
        const popupSuccess = form.parentElement.querySelector(VALIDATE_ELEMENTS.popupSuccess);

        if (!submitButton || !validateFields) { return false; }

        submitButton.addEventListener('click', () => {
            validateFields.forEach((field) => {
                inputValidate(field, submitButton);

                field.addEventListener('input', () => {
                    inputValidate(field, submitButton);
                });
            });

            const selectItem = document.querySelectorAll(VALIDATE_ELEMENTS.selectItem);
            // TODO: переделать, пока временная заплатка
            selectItem.forEach((elem) => {
                elem.addEventListener('click', () => {
                    const selectWrapper = elem.closest(VALIDATE_ELEMENTS.container);
                    const selectInput = selectWrapper.querySelector(VALIDATE_ELEMENTS.fields);
                    inputValidate(selectInput, submitButton);
                });
            });
            if (checkForm(submitButton)) {
                if (popup && popupSuccess) {
                    popup.classList.add(VALIDATE_ELEMENTS.popupHideClassName);
                    popupSuccess.classList.remove(VALIDATE_ELEMENTS.popupHideClassName);
                }

                // TODO: переделать, временный костыль
                if (!popup && popupSuccess) {
                    const popupSuccessWrapper = form.parentElement.querySelector(VALIDATE_ELEMENTS.popupWrapper);

                    document.body.classList.add(STATE.disableScroll);
                    popupSuccessWrapper.classList.add(VALIDATE_ELEMENTS.popupShowClassName);
                    popupSuccess.classList.remove(VALIDATE_ELEMENTS.popupHideClassName);

                    popupSuccessWrapper.querySelector(VALIDATE_ELEMENTS.popupClose).addEventListener('click', () => {
                        popupSuccessWrapper.classList.remove(VALIDATE_ELEMENTS.popupShowClassName);
                        document.body.classList.remove(STATE.disableScroll);
                    });
                }
            }
        });
    });
}
